import type { ConfigContract } from "../types";

export default {
  TAMEENI_HOME: "https://www.tameeni.com",
  API_BASE_URL: "https://travel.tameeni.com/backend/api/v1/",
  CONNECTION_API_URL: "https://travel.tameeni.com/backend/QuoteNotifierHub",
  AMEEN_URL: "https://www.tameeni.com/ameen",
  IDENTITY_URL: "https://identity.tameeni.com/",
  IDENTITY_CLIENT_ID: "Travel",
  IDENTITY_CLIENT_SECRET: "Secret12345",
  IDENTITY_REDIRECT_URL: "https://travel.tameeni.com",
  APP_URL: "https://travel.tameeni.com/",
  OTP_TIMER: 3,
  SESSION_MAX_AGE: 10 * 24 * 60 * 60,
  IS_LOGIN_ENFORCE: true,
  NEXT_PUBLIC_APP_ENV: "production",
  NEXTAUTH_URL: "https://travel.tameeni.com",
  AUTH_TRUST_HOST: "true",
  NEXT_PUBLIC_GTM_ENABLED: "true",
  NEXT_PUBLIC_GTM_ID: "GTM-K7FZCSM",
  FILTER_MIN_QUOTATIONS: 4,
} satisfies ConfigContract;
